module.exports = "/_next/static/resources/art-47cbe6415c0e239589239b2450e22664.jpg";